import url from '@/creditflowresearch/infrastructure/url';

const getBwicsInventoryMetaSchema = (pathname: string, bondType: string, assetClass: string) => {
  if (!assetClass) {
    return null;
  }
  return {
    '@type': 'WebPage',
    // FIXME: pathname value based on next/router value, which contains pattern instead of real value
    // bwics-inventories/[bondType]/[assetClass]
    url: url.getUrl(pathname),
    name: `Fixed Income ${ assetClass } ${ bondType }`,
    description: 'Supercharge your ABS BWIC & Inventory discovery process. Seamlessly explore BWICS & Inventory from participating dealers.',
    keywords: [assetClass, 'fixed income', 'inventories', 'bwics'],
  };
};

export default getBwicsInventoryMetaSchema;
